import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const taskMap: TaskMap = {
  [TaskName.COMPUTE_DEPLOY]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Compute cluster created'),
      message: i18n.t('Compute cluster successfully created'),
    }),
    [TaskState.RUNNING]: ({ progress = 0 }) => ({
      title: i18n.t('Creating compute cluster...'),
      message: i18n.t('{0}% completed', [progress])
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error creating compute cluster'),
      message: error,
    })
  },
  [TaskName.COMPUTE_DESTROY]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Compute cluster deleted'),
      message: i18n.t('Compute cluster successfully deleted'),
    }),
    [TaskState.RUNNING]: () => ({
      title: undefined,
      message: i18n.t('Deleting compute cluster...'),
      progress: undefined
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error deleting compute cluster'),
      message: error,
    })
  },
  [TaskName.COMPUTE_JOINING_NODE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Node added'),
      message: i18n.t('Node successfully added to compute cluster')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Adding node to compute cluster...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Failed to add node to compute cluster'),
      message: error
    })
  },
  [TaskName.COMPUTE_RELEASE_NODE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Node released'),
      message: i18n.t('Node successfully released'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Releasing node from compute cluster...',)
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Failed to release node from compute cluster'),
      message: error
    })
  },
  [TaskName.COMPUTE_NETWORK_CREATE]: {
    [TaskState.SUCCESS]: ({ result }) => ({
      title: i18n.t('Physical network created'),
      message: i18n.t('Physical network "{name}" successfully created', { name: result.name })
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Creating physical network...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error creating physical network'),
      message: error
    })
  },
  [TaskName.COMPUTE_NETWORK_DELETE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Physical network deleted'),
      message: i18n.t('Physical network successfully deleted')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Deleting physical network...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error deleting physical network'),
      message: error
    })
  },
  [TaskName.DRS_POLICY_STATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Policy state updated'),
      message: i18n.t('Policy state successfully updated')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Updating policy state...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error updating policy state'),
      message: error
    })
  },
  [TaskName.DRS_POLICY_PARAMS_UPDATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Policy changed'),
      message: i18n.t('Policy successfully changed')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Updating policy...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Failed to change policy'),
      message: error
    })
  }
};

export default taskMap;
